import { put, select, call } from 'redux-saga/effects';
import { getTeeTimes, createPreReservation } from '../../services/api';
import * as Constants from '../../actions';

export const teeTimeSearch = function* (action) {
    yield put({ type: Constants.TEETIMES_FETCHING });
    const { data: response } = yield call(getTeeTimes, action.payload);
    if(response.error){
        console.warn(response.message);
    }
    yield put({ type: Constants.TEETIMES_RESPONSE, payload: response.error ? [] : response });
}

export const preReservation = (facilityid) => function* () {
    yield put({ type: Constants.CREATING_RESERVATION });
     const payload = yield select(state => ({
         teeTimeRateId: state.selectedTeeTime.teetime,
         numberOfPlayers: state.selectedTeeTime.golfers,
         courseId: facilityid
     }))

    const { data: response } = yield call(createPreReservation, payload);

    if (response.error) {
        // this is the case that rate is unavailible
        const { errorCode, message } = response;
        if(errorCode === 10){
            yield put({ type: Constants.TEETIME_UNAVAILIBLE, payload: message });
        }
        else {
            yield put({ type: Constants.RESERVATION_FAILED, payload: message});
        }
    }
    else {
        yield put({ type: Constants.RESERVATION_PLACED, payload: response });
    }
}



// WEBPACK FOOTER //
// ./src/sagas/api/task.js